export default "__VITE_ASSET__Bcqf8T5P__"